import {
  type AdherentSummary,
  type ApiRoleStrategy,
  ROLES,
  api,
  useMyAdherentSummary,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useAdherentSummaryApi = ({
  adherentId,
}: { adherentId?: string } = {}) => {
  if (!adherentId) {
    return useMyAdherentSummary()
  }

  const { endpoint, queryKey } = useRoleConf(apiRoleConf(adherentId))
  const { data: summary, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: () => api.get<AdherentSummary>(endpoint),
    enabled: !!endpoint,
  })
  return { summary, isLoading }
}

const presidentApiRoleConf = (id: string) => ({
  endpoint: `/api/adherents/president/${id}/summary`,
  queryKey: ["adherents", "president", id, "summary"],
})

export const apiRoleConf = (id: string): ApiRoleStrategy => ({
  [ROLES.UPP_PRESIDENT]: presidentApiRoleConf(id),
  [ROLES.UPP_REPRESENTATIVE]: presidentApiRoleConf(id),
  [ROLES.ADHERENT_ADVISOR]: {
    endpoint: `/api/adherents/my-sector/${id}/summary`,
    queryKey: ["adherents", "my-sector", id, "summary"],
  },
  [ROLES.ADMIN]: {
    endpoint: `/api/adherents/${id}/summary`,
    queryKey: ["adherents", id, "summary"],
  },
})
